import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';
import { zip } from 'utils/form';
// import Client from 'containers/app/client';

import { UploadOutlined } from '@ant-design/icons';

import fields from 'containers/worker/dbs-check/fields';
import DBSFormModal from '../dbs-form-modal';

const UploadDBS = ({ id, ...rest }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const initialValues = zip(fields, rest);

  return (
    <>
      <Button
        onClick={() => {
          setIsModalOpen(true);
        }}
        type="primary"
        icon={<UploadOutlined />}
        size="small"
      >
        Change information
      </Button>

      <Modal
        className="dbs-form-modal"
        title="DBS Info"
        visible={isModalOpen}
        footer={null}
        onCancel={() => {
          setIsModalOpen(false);
        }}
      >
        <DBSFormModal
          uid={id}
          initialValues={initialValues}
          onBack={() => {
            setIsModalOpen(false);
          }}
          onSubmit={() => {
            setIsModalOpen(false);
          }}
        />
      </Modal>
    </>
  );
};

UploadDBS.propTypes = {
  id: PropTypes.string.isRequired,
};

export default UploadDBS;
